<div
  class="main-header"
  style="position: relative !important; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.02); display:flex; justify-content:space-between; align-items:center"
>
  <app-top-search-bar class="fms-top-header-search-bar"></app-top-search-bar>

  <div class="new-head">
    <span
      *ngIf="(isFreemium$ | async) && !isCompanyUser"
      class="hs-cta-wrapper fms-header-cta-upgrade-container"
      id="hs-cta-wrapper-27e29fea-8b44-45d2-ae2e-ed4ae52a6498"
    >
      <span
        class="hs-cta-node hs-cta-27e29fea-8b44-45d2-ae2e-ed4ae52a6498"
        id="hs-cta-27e29fea-8b44-45d2-ae2e-ed4ae52a6498"
      >
        <a
          vng-button
          variant="brand"
          size="md"
          href="https://cta-redirect.hubspot.com/cta/redirect/11964/27e29fea-8b44-45d2-ae2e-ed4ae52a6498"
          class="fms-header-cta-upgrade"
          id="fms-header-cta-upgrade-subscription"
          data-fms-heap="fms-header-cta-upgrade-subscription"
        >
          <vng-icon name="star_border" [outline]="false" color="inherit"></vng-icon>
          <span class="fms-link-title">Upgrade Subscription</span>
        </a>
      </span>
      <script charset="utf-8" src="https://js.hscta.net/cta/current.js"></script>
      <script type="text/javascript">
        hbspt.cta.load(11964, "27e29fea-8b44-45d2-ae2e-ed4ae52a6498", {
          useNewLoader: "true",
          region: "na1",
        });
      </script>
    </span>

    <app-notification-bell *ngIf="showNotificationCenter"></app-notification-bell>

    <div
      [vngMenuTriggerFor]="user"
      (click)="onMenuOpened()"
      class="user-info cursor-point"
      style="display:flex; justify-content:flex-start; align-items:center; gap:5px"
    >
      <div class="profile-img">
        <vng-icon name="person" [outline]="false" color="inherit" *ngIf="!avatarSrc || avatarFailed"></vng-icon>
        <img *ngIf="avatarSrc && !avatarFailed" [src]="avatarSrc" alt="" (error)="avatarFailed = true" />
      </div>
    </div>

    <vng-menu #user>
      <div class="menu-dropdown">
        <div class="profile">
          <p class="profile-name">{{ userDetail.first_name }} {{ userDetail.last_name }}</p>
          <p class="profile-email" (click)="copyToClipboard(userDetail.email)" [title]="userDetail.email">
            {{ userDetail.email }}
          </p>
          <div *ngIf="userDetail?.company?.name && !invitedToCompany" class="profile-company">
            <span> {{ userDetail.company.name }} </span>
          </div>

          <p class="profile-plan">Current Plan: {{ planId$ | async }}</p>

          <button
            style="margin-top: 10px"
            (click)="user.closeRequested.emit(); goToProfile()"
            vng-button
            variant="primary"
          >
            View or edit profile
          </button>
        </div>

        <div class="menu">
          <div
            *ngIf="showAdminSection"
            class="menu-item"
            (click)="user.closeRequested.emit(); goToAdmin()"
            style="color: var(--vng-color-accent)"
          >
            <span> Account Center </span>
            <svg-icon-sprite
              class="menu-icon"
              width="18px"
              height="18px"
              viewBox="0 0 80 80"
              src="icon-route-away"
              style="display: flex; align-items: flex-end; margin-left: 5px"
            >
            </svg-icon-sprite>
          </div>
          <div
            *ngIf="showCMCSection"
            class="menu-item"
            (click)="user.closeRequested.emit(); goToCMCAdmin()"
            style="color: var(--vng-color-accent)"
          >
            <span> Client Management Center </span>
            <svg-icon-sprite
              class="menu-icon"
              width="18px"
              height="18px"
              viewBox="0 0 80 80"
              src="icon-route-away"
              style="display: flex; align-items: flex-end; margin-left: 5px"
            >
            </svg-icon-sprite>
          </div>
          <div class="menu-item" (click)="user.closeRequested.emit(); goToSettings()">
            <span (click)="trackService.btnClickUpdatetrack('clicked_settings')"> Account & Subscription </span>
          </div>
          <div *ngIf="canUpgrade" class="menu-item" (click)="user.closeRequested.emit(); handleUpgradePlan()">
            <span>
              <a style="color: var(--vng-color-accent)"> Upgrade Plan </a>
            </span>
          </div>
          <div
            class="menu-item"
            (click)="user.closeRequested.emit(); navigateTo('https://vengreso.com/request-appointment')"
          >
            <span (click)="trackService.btnClickUpdatetrack('clicked_contact_sales')"> Contact Sales </span>
          </div>
          <div class="menu-item" (click)="user.closeRequested.emit(); navigateToExtension()">
            <span> Install Chrome or Edge Extension </span>
          </div>
          <div class="menu-item" style="margin-bottom: -19px" (click)="user.closeRequested.emit(); logOut()">
            Sign Out
          </div>
        </div>
      </div>
    </vng-menu>
  </div>
</div>
<div *ngIf="invitedToCompany" style="display:flex; justify-content:space-between; align-items:center" class="invitation-header">
  <span class="font-weight-bold">
    {{ userDetail.invited_to_company_by_admin }} invited you to join their {{ userDetail.company.name }} Company
  </span>
  <button vng-button variant="outline" type="button" (click)="rejectInvitation()">Reject</button>
  <button (click)="acceptInvitation()" vng-button variant="primary">Accept Invitation</button>
</div>
